export default function getShiftIdsFromOrders(orders) {
  return [...new Set(orders.map(order => order.shiftId))].reverse()
}
